<template>
  <div class="profile">
<!--    <div class="banner">-->
<!--      <img src="../assets/profileBanner.jpg" />-->
<!--    </div>-->
    <div class="content">
      <h2>招聘要求</h2>
      <div>
        <div class="label">一、招聘对象</div>
        <p>2024年国内外“211”、“985”院校和“双一流”高校的本科及以上应届毕业生。</p>
        <div class="label">二、基本要求</div>
        <p>1.遵守国家法律法规，政治素质高，责任心强，无违规违纪行为。</p>
        <p>2.思想上进，态度端正，爱岗敬业，甘于奉献，恪守职业道德。</p>
        <p>3.具备较突出的组织协调和沟通能力，良好的服务意识和团队协作精神。</p>
        <p>4.专业知识扎实，学习成绩优良的全日制应届毕业生。</p>
        <p>5.品行端正，身体健康，适应野外工作。</p>
        <p>6.双一流学科及获得“优秀毕业生”、“三好学生”等称号的应届毕业生优先考虑。</p>
        <div class="label">三、招聘流程</div>
<!--        <p>1.请点击页面右上角的“提交简历”进行简历信息投递，个人简历文件名格式：“专业-姓名-学历-学校”，或登录企业官网（<a href="http://www.bgi.com.cn" target="_blank">www.bgi.com.cn</a>），点击“加入北勘”，进行简历投递。</p>-->
        <p>请点击登录企业官网（<a href="http://www.bgi.com.cn" target="_blank">www.bgi.com.cn</a>），点击“加入北勘”，进行网上相关信息的填写与简历投递，个人简历的文件名格式：“专业-姓名-学历-学校”。</p>
<!--        <p>2.本次春季招聘设集中面试时间：2022年3月20日 - 3月25日、2022年4月15日 - 4月20日。</p>-->
<!--        <p>3.本次春季招聘截止日期为2022年4月20日。</p>-->
        <div class="label">四、联系方式</div>
        <p>联系部门：北京市勘察设计研究院有限公司人力资源部</p>
        <p><span class="lianxiren">联系人</span>：张老师、丁老师</p>
        <p style="display: flex">
            <span style="width: 120px">联系电话：</span>
            <span style="">
                <div style="text-indent: 0">010-63987285</div>
                <div style="text-indent: 0">010-63951970</div>
            </span>


        </p>
<!--        <p>邮　　箱：bgi2005@sina.com</p>-->
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Footer from "../base/Footer";

export default {
  name: "Profile",
  props: {},
  components: { Footer },
  methods: {
    handleSelect(key, keyPath) {},
  },
  data() {
    return {
      search: "",
      activeIndex: "1",
    };
  },
};
</script>

<style scoped lang="less">
.profile {
  width: 100%;
  background: #fff;
  .banner {
    margin-top: 60px;
    height: 250px;
    img {
      height: 100%;
      width: 100%;
    }
  }
  .content {
    margin: 100px auto 50px;
    width: 1000px;
    background: #fff;
    h2 {
      font-size: 26px;
      margin: 30px 0;
      letter-spacing: 8px;
      font-weight: 700;
      color: #102b6a;
    }
    .label{
      text-align: left;
      font-weight: 600;
      font-size: 18px;
      margin-bottom: 30px;
      margin-top: 30px;
    }

    p {
      line-height: 40px;
      margin-bottom: 15px;
      text-align: left;
      text-indent: 35px;
    }
    .lianxiren{
      letter-spacing: 5px;

    }

    /*span {*/
    /*  font-size: 20px;*/
    /*  color: #006eab;*/
    /*  font-weight: 600;*/
    /*}*/
  }
}
</style>
